import ApiHelper from 'src/utils/api/api_helper'

class Ubi {
    static async convDs(items, layoutCd){
        let ds = [];

        Ubi.dsLayout = Ubi.layout[layoutCd];
        Ubi.dsSample = Ubi.sample[layoutCd];

        // if(corpNm === 'incar') {
        //     if(formCatCd === '40') {
        //         Ubi.dsLayout = Ubi.etcLayout;
        //         Ubi.dsSample = Ubi.etcSample;
        //     } else {
        //         Ubi.dsLayout = Ubi.layout;
        //         Ubi.dsSample = Ubi.sample;
        //     }
        // } else {
        //     Ubi.dsLayout = Ubi.globalLayout;
        //     Ubi.dsSample = Ubi.globalSample;
        // }
        
        for(let item of Object.keys(items)){
            ds.push(await Ubi.toDsString(item, await Ubi.toDsArray(item, items[item])));
        }
        return ds.join("");
    }

    static async base64ToUrl(base64){
        if(base64 == '') return '';
        if(base64 === undefined) return '';
        let url;
        await ApiHelper.request(ApiHelper.methods.post, "/ubi/exportImage", {data: base64})
                    .then((res) => {
                        return res.data;
                    }).then((data) => {
                        url = data.data.url;
                    });

        return ApiHelper.baseURL + url;
    }
    
    // dsInfo 를 dsArray 로 변환
    static async toDsArray(dsName, ds){
        if(Ubi.dsLayout[dsName] === undefined) return "";

        let dsLayout = Ubi.dsLayout[dsName];
        let dsArray = []
        for(let row of ds){
            let dsRow = [];
            for(let col of dsLayout) {
                let val = ''
                if(col.type=='img'){
                    val = await Ubi.base64ToUrl(row[col.id]);
                } else {
                    val = row[col.id];
                }            
                dsRow.push(val);
            }
            dsArray.push(dsRow);
        }
        return dsArray
    }

    // dsArray 를 dsString 으로 변환
    static async toDsString(dsName, ds){
        if(ds == "") return "";

        let dsString = dsName + '#"';
        ds.forEach((row) => {
            let rowString = "";
            row.forEach((item) => {
                rowString += item + '^t';
            });
            dsString += rowString + '^n';
        });
        dsString += '"#'
        return dsString;
    }
}

Ubi.dsLayout = {};
Ubi.layout = {
    BASIC: {
        ds_info: [
            {id: 'SBMS_DT'},
            {id: 'NAME'},
            {id: 'BDT'},
            {id: 'SEX'},
            {id: 'HPHN_NO'},
            {id: 'RES_REG_NO'},
            {id: 'EMAL'},
            {id: 'ADDR'},
            {id: 'BANK_NM'},
            {id: 'ACT_NO'},
            {id: 'RECR_NM'},
            {id: 'RECR_OFLV'},
            {id: 'RECR_EMP_NO'},
            {id: 'RECR_TEL'},
            {id: 'GRP_NM'},
            {id: 'BR_NM'},
            {id: 'ID_COPY'},
            {id: 'HDWT01', type: 'img'},
            {id: 'HDWT02', type: 'img'},
            {id: 'HDWT03', type: 'img'},
            {id: 'HDWT04', type: 'img'},
            {id: 'HDWT05', type: 'img'},
            {id: 'HDWT06', type: 'img'},
            {id: 'HDWT07', type: 'img'},
            {id: 'HDWT08', type: 'img'},
            {id: 'HDWT09', type: 'img'},
            {id: 'HDWT10', type: 'img'},
            {id: 'ISNC_NUM'},
            {id: 'FIN_ACDNT_YN'},
            {id: 'FIN_ACDNT_CORP_NM'},
            {id: 'FIN_ACDNT_KIND'},
            {id: 'ACDNT_DTM'},
            {id: 'ACDNT_CTNT'},
            {id: 'ACDNT_DTL_CTNT'},
            {id: 'DISS_FIN_YN'},
            {id: 'DISS_CORP_NM'},
            {id: 'DISS_FIN_ACDNT_KIND'},
            {id: 'DISS_DTM'},
            {id: 'DISS_DTL_CTNT'},
            {id: 'AGREE_YN'}
        ],
        ds_file: [
            {id: 'TITLE'},
            {id: 'FILE'},
        ]   
    },
    ADD: {
        ds_info: [
            {id: 'SBMS_DT'},
            {id: 'NAME'},
            {id: 'BDT'},
            {id: 'SEX'},
            {id: 'HPHN_NO'},
            {id: 'RES_REG_NO'},
            {id: 'EMAL'},
            {id: 'ADDR'},
            {id: 'BANK_NM'},
            {id: 'ACT_NO'},
            {id: 'RECR_NM'},
            {id: 'RECR_OFLV'},
            {id: 'RECR_EMP_NO'},
            {id: 'RECR_TEL'},
            {id: 'GRP_NM'},
            {id: 'BR_NM'},
            {id: 'ID_COPY'},
            {id: 'HDWT01', type: 'img'},
            {id: 'HDWT02', type: 'img'},
            {id: 'HDWT03', type: 'img'},
            {id: 'HDWT04', type: 'img'},
            {id: 'HDWT05', type: 'img'},
            {id: 'HDWT06', type: 'img'},
            {id: 'HDWT07', type: 'img'},
            {id: 'HDWT08', type: 'img'},
            {id: 'HDWT09', type: 'img'},
            {id: 'HDWT10', type: 'img'},
            {id: 'HDWT11', type: 'img'},
            {id: 'HDWT12', type: 'img'},
            {id: 'HDWT13', type: 'img'},
            {id: 'HDWT14', type: 'img'},
            {id: 'HDWT15', type: 'img'},
            {id: 'HDWT16', type: 'img'},
            {id: 'HDWT17', type: 'img'},
            {id: 'HDWT18', type: 'img'},
            {id: 'HDWT19', type: 'img'},
            {id: 'HDWT20', type: 'img'},
            {id: 'ISNC_NUM'},
            {id: 'EDU_LEVEL'}
        ],
        ds_file: [
            {id: 'TITLE'},
            {id: 'FILE'},
        ]   
    },
    INCAR: {
        ds_info: [
            {id: 'SBMS_DT'},
            {id: 'NAME'},
            {id: 'BDT'},
            {id: 'CRER_YN'},
            {id: 'QLFC_YN'},
            {id: 'HPHN_NO'},
            {id: 'RES_REG_NO'},
            {id: 'ADDR'},
            {id: 'RECR_NM'},
            {id: 'RECR_OFLV'},
            {id: 'RECR_EMP_NO'},
            {id: 'RECR_TEL'},
            {id: 'GRP_NM'},
            {id: 'BR_NM'},
            {id: 'BR_CD'},
            {id: 'ID_COPY'},
            {id: 'HDWT01', type: 'img'},
            {id: 'HDWT02', type: 'img'},
            {id: 'HDWT03', type: 'img'},
            {id: 'HDWT04', type: 'img'},
            {id: 'HDWT05', type: 'img'},
            {id: 'HDWT06', type: 'img'},
            {id: 'HDWT07', type: 'img'},
            {id: 'HDWT08', type: 'img'},
            {id: 'HDWT09', type: 'img'},
            {id: 'HDWT10', type: 'img'},
            {id: 'EMAL'},
            {id: 'ECLEAN_YN'}
        ],
        ds_file: [
            {id: 'TITLE'},
            {id: 'FILE'}
        ]
    },
    ETC: {
        ds_info: [
            {id: 'BR_NM'},
            {id: 'NAME'},
            {id: 'BDT'},
            {id: 'CRER_YN'},
            {id: 'A10001'},
            {id: 'A10002'},
            {id: 'A10003'},
            {id: 'A10004'},
            {id: 'A10005'},
            {id: 'A10006'},
            {id: 'A10008'},
            {id: 'A10009'},
            {id: 'A10010'},
            {id: 'A10011'},
            {id: 'A10012'},
            {id: 'A10013'},
            {id: 'A10021'},
            {id: 'A10023'},
            {id: 'A10024'},
            {id: 'A10025'},
            {id: 'A10026'},
            {id: 'A10028'},
            {id: 'A10022'},
            {id: 'A10029'},
            {id: 'A10031'},
        ],
        ds_file: [
            {id: 'TITLE'},
            {id: 'FILE'}
        ]
    }
};

Ubi.dsSample = {};
Ubi.sample = {
    BASIC: {
        ds_info: [{
            'SBMS_DT': '202100701',
            'NAME': '홍길동',
            'BDT': '19810101',
            'SEX': '남',
            'HPHN_NO': '010-1234-1234',
            'RES_REG_NO': '810101-1912345',
            'EMAL': 'agencypro@agencypro.co.kr',
            'ADDR': '(52839) 서울시 금천구 가산디지털2로 108 716호(가산동, 뉴티캐슬)',
            'BANK_NM': '국민은행',
            'ACT_NO': '011-2342-123444',
            'RECR_NM': '김길동',
            'RECR_OFLV': '팀장',
            'RECR_EMP_NO': 'EMP00001',
            'RECR_TEL': '010-4321-4321',
            'GRP_NM': '서울사업부',
            'BR_NM': '금천가산영업지점',
            'ID_COPY': '',
            'HDWT01': 'data:image/png;base64,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',
            'HDWT02': '',
            'HDWT03': '',
            'HDWT04': '',
            'HDWT05': '',
            'HDWT06': '',
            'HDWT07': '',
            'HDWT08': '',
            'HDWT09': '',
            'HDWT10': '',
            // 'ISNC_NUM' : 'EZP1-20240306111338-21005-10',
            'FIN_ACDNT_YN': 'Y',
            'FIN_ACDNT_CORP_NM': '회사',
            'FIN_ACDNT_KIND': '유형',
            'ACDNT_DTM': '일자',
            'ACDNT_CTNT': '내용',
            'ACDNT_DTL_CTNT': '내용',
            'DISS_FIN_YN': 'Y',
            'DISS_CORP_NM': '회사',
            'DISS_FIN_ACDNT_KIND': '유형',
            'DISS_DTM': '일자',
            'DISS_DTL_CTNT': '내용',
            'AGREE_YN': 'Y'
        }],
        ds_file: [{
                'TITLE': '가족관계증명서 1/2',
                'FILE': 'http://localhost:3000/'
            },
            {
                'TITLE': '가족관계증명서 2/2',
                'FILE': 'http://localhost:3000/'
            }]
    },
    ADD: {
        ds_info: [{
            'SBMS_DT': '202100701',
            'NAME': '홍길동',
            'BDT': '19810101',
            'SEX': '남',
            'HPHN_NO': '010-1234-1234',
            'RES_REG_NO': '810101-1912345',
            'EMAL': 'agencypro@agencypro.co.kr',
            'ADDR': '(52839) 서울시 금천구 가산디지털2로 108 716호(가산동, 뉴티캐슬)',
            'BANK_NM': '국민은행',
            'ACT_NO': '011-2342-123444',
            'RECR_NM': '김길동',
            'RECR_OFLV': '팀장',
            'RECR_EMP_NO': 'EMP00001',
            'RECR_TEL': '010-4321-4321',
            'GRP_NM': '서울사업부',
            'BR_NM': '금천가산영업지점',
            'ID_COPY': '',
            'HDWT01': 'data:image/png;base64,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',
            'HDWT02': '',
            'HDWT03': '',
            'HDWT04': '',
            'HDWT05': '',
            'HDWT06': '',
            'HDWT07': '',
            'HDWT08': '',
            'HDWT09': '',
            'HDWT10': '',
            'HDWT11': '',
            'HDWT12': '',
            'HDWT13': '',
            'HDWT14': '',
            'HDWT15': '',
            'HDWT16': '',
            'HDWT17': '',
            'HDWT18': '',
            'HDWT19': '',
            'HDWT20': '',
            // 'ISNC_NUM' : 'EZP1-20240306111338-21005-10',
        }],
        ds_file: [{
                'TITLE': '가족관계증명서 1/2',
                'FILE': 'http://localhost:3000/'
            },
            {
                'TITLE': '가족관계증명서 2/2',
                'FILE': 'http://localhost:3000/'
            }]
    },
    INCAR: {
        ds_info: [{
            'SBMS_DT': '202100701',
            'NAME': '홍길동',
            'BDT': '19810101',
            'CRER_YN': 'Y',
            'QLFC_YN': 'Y',
            'HPHN_NO': '010-1234-1234',
            'RES_REG_NO': '810101-1912345',
            'ADDR': '서울시 금천구 가산디지털2로 108 716호(가산동, 뉴티캐슬)',
            'RECR_NM': '김길동',
            'RECR_OFLV': '팀장',
            'RECR_EMP_NO': 'EMP00001',
            'RECR_TEL': '010-4321-4321',
            'GRP_NM': '다이렉트',
            'BR_NM': '다이렉트서울',
            'BR_CD': 'ABC12345',
            'ID_COPY': '',
            'HDWT01': 'data:image/png;base64,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',
            'HDWT02': '',
            'HDWT03': '',
            'HDWT04': '',
            'HDWT05': '',
            'HDWT06': '',
            'HDWT07': '',
            'HDWT08': '',
            'HDWT09': '',
            'HDWT10': '',
            'EMAL': 'agencypro@agencypro.co.kr',
            'ECLEAN_YN': 'Y'
        }],
        ds_file: [{
                'TITLE': '교육수료증 1/1',
                'FILE': 'http://localhost:3000/'
            },
            {
                'TITLE': '시헙합격증 1/1',
                'FILE': 'http://localhost:3000/'
            }]
    },
    ETC: {
        ds_info: [{
            'BR_NM': '에이전시프로',
            'NAME': '홍길동',
            'BDT': '19810101',
            'CRER_YN': 'N',
            'A10001': 'Y',
            'A10002': 'Y',
            'A10003': 'Y',
            'A10004': 'Y',
            'A10005': 'Y',
            'A10006': 'Y',
            'A10008': 'Y',
            'A10009': 'Y',
            'A10010': 'Y',
            'A10011': 'N',
            'A10012': 'N',
            'A10013': 'N',
            'A10021': 'N',
            'A10023': 'N',
            'A10024': 'N',
            'A10025': 'Y',
            'A10026': 'Y',
            'A10028': 'Y',
            'A10022': 'Y',
            'A10029': 'Y',
            'A10031': 'Y',
        }],
        ds_file: [{
                'TITLE': '교육수료증 1/1',
                'FILE': 'http://localhost:3000/'
            },
            {
                'TITLE': '시헙합격증 1/1',
                'FILE': 'http://localhost:3000/'
            }]
    }
};

export default Ubi;
